module.exports = __webpack_public_path__ + "static/media/clientesinstitucionales.00ffda28.svg";